import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Users, MessageCircle } from "lucide-react";
import { FaFacebookF } from "react-icons/fa";
import api from "@/lib/api";

export const Grupa = () => {
    const [settings, setSettings] = useState({ facebook_group_url: "" });

    useEffect(() => {
        api.get("/settings")
            .then((r) => setSettings(r.data || {}))
            .catch(() => { /* keep defaults */ });
    }, []);

    const fb = (settings.facebook_group_url || "").trim();

    return (
        <section id="grupa" data-testid="grupa-section" className="py-24 md:py-32 bg-[#0D4F3C] text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-0 w-96 h-96 rounded-full bg-[#D4A537] blur-3xl" />
                <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white blur-3xl" />
            </div>

            <div className="max-w-6xl mx-auto px-6 lg:px-10 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center max-w-3xl mx-auto mb-14"
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#D4A537]/20 mb-6">
                        <Users className="text-[#D4A537]" size={28} />
                    </div>
                    <p className="text-[#D4A537] uppercase tracking-[0.25em] text-xs font-semibold mb-4">Społeczność</p>
                    <h2 className="font-serif text-4xl md:text-5xl leading-tight mb-5">
                        Grupa osiedlowa – bądź na bieżąco
                    </h2>
                    <p className="text-white/80 text-base md:text-lg">
                        Dołącz do społeczności mieszkańców Dąbrówki Wiślanej. Wymieniaj się informacjami,
                        bierz udział w dyskusjach i poznawaj sąsiadów.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-1 gap-6 max-w-2xl mx-auto">
                    <SocialCard
                        href={fb || "#grupa"}
                        disabled={!fb}
                        bg="bg-[#1877F2]"
                        Icon={FaFacebookF}
                        title="Grupa na Facebooku"
                        subtitle={fb ? "Aktualne dyskusje, wydarzenia i ogłoszenia mieszkańców." : "Link zostanie wkrótce dodany przez administratora."}
                        testid="grupa-facebook"
                    />
                </div>

                {!fb && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        className="mt-12 flex items-center justify-center gap-3 text-white/60 text-sm"
                    >
                        <MessageCircle size={16} />
                        <span>Linki do grup zostaną wkrótce zaktualizowane przez administratora.</span>
                    </motion.div>
                )}
            </div>
        </section>
    );
};

const SocialCard = ({ href, disabled, bg, Icon, title, subtitle, testid }) => (
    <motion.a
        href={href}
        target={disabled ? undefined : "_blank"}
        rel="noopener noreferrer"
        data-testid={testid}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        whileHover={{ y: disabled ? 0 : -6 }}
        className={`group flex items-center gap-5 p-7 md:p-8 rounded-3xl bg-white/5 backdrop-blur border border-white/10 transition-all duration-300 ${
            disabled ? "opacity-60 cursor-not-allowed" : "hover:border-[#D4A537]/50 hover:bg-white/10"
        }`}
        onClick={(e) => disabled && e.preventDefault()}
    >
        <div className={`shrink-0 w-16 h-16 rounded-2xl ${bg} flex items-center justify-center text-white group-hover:scale-110 transition-transform`}>
            <Icon size={26} />
        </div>
        <div className="flex-1">
            <h3 className="font-serif text-2xl mb-1">{title}</h3>
            <p className="text-white/70 text-sm">{subtitle}</p>
        </div>
        {!disabled && <span className="text-[#D4A537] text-2xl group-hover:translate-x-1 transition-transform">→</span>}
    </motion.a>
);

export default Grupa;
